import React from 'react';
import { Button, Icon, Tag } from 'antd';

export default function WalkthroughHeader({
  heading,
  currentVideo,
  videoIndex,
  stepCount,
  videos,
  accentColor,
  participant,
  statusLabel,
  isCancelled,
  isSubmitted,
  onBack,
  onGoToVideo,
  headingRef,
}) {
  return (
    <header className="testing-exercising-walkthrough__header">
      <div className="testing-exercising-walkthrough__toolbar">
        <Button className="testing-exercising-walkthrough__back" icon="arrow-left" onClick={onBack}>
          Back to scenarios
        </Button>
        <div className="testing-exercising-walkthrough__meta">
          <span className="testing-exercising-walkthrough__meta-item">
            <span className="testing-exercising-walkthrough__meta-label">Participant</span>
            <strong>{participant || '—'}</strong>
          </span>
          <Tag color={isCancelled ? 'red' : isSubmitted ? 'green' : accentColor || 'blue'}>{statusLabel || 'Draft'}</Tag>
        </div>
      </div>

      <div
        ref={headingRef}
        id="testing-exercising-walkthrough-heading"
        className="testing-exercising-walkthrough__title-block"
      >
        <h1>{heading}</h1>
        <p className="testing-exercising-walkthrough__subtitle">
          {currentVideo
            ? `Video ${videoIndex + 1} of ${stepCount} — ${currentVideo.heading}${
                currentVideo.videoTiming ? ` (${currentVideo.videoTiming})` : ''
              }`
            : 'Scenario walkthrough'}
        </p>
        <div
          className="testing-exercising-walkthrough__progress"
          role="progressbar"
          aria-label="Walkthrough progress"
          aria-valuemin={1}
          aria-valuemax={stepCount}
          aria-valuenow={Math.min(videoIndex + 1, stepCount)}
        >
          <span style={{ width: `${(Math.min(videoIndex + 1, stepCount) / stepCount) * 100}%` }} />
        </div>
      </div>

      {videos.length > 1 ? (
        <nav className="testing-exercising-walkthrough__steps" aria-label="Video steps">
          <div className="testing-exercising-walkthrough__steps-label">Jump to video</div>
          <ol className="testing-exercising-walkthrough__steps-list">
            {videos.map((video, index) => {
              const isCurrent = index === videoIndex;
              const isDone = index < videoIndex;
              return (
                <li key={video.videoId}>
                  <button
                    type="button"
                    className={[
                      'testing-exercising-walkthrough__step',
                      isCurrent ? 'is-current' : '',
                      isDone ? 'is-done' : '',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                    aria-current={isCurrent ? 'step' : undefined}
                    onClick={() => onGoToVideo(index)}
                  >
                    <span className="testing-exercising-walkthrough__step-num">
                      {isDone ? <Icon type="check" aria-label={`Video ${index + 1} completed`} /> : index + 1}
                    </span>
                    <span className="testing-exercising-walkthrough__step-title">
                      {video.heading || `Video ${index + 1}`}
                    </span>
                  </button>
                </li>
              );
            })}
          </ol>
        </nav>
      ) : null}
    </header>
  );
}
